import {
  AppMarketSmall,
  SendSmall,
  CouponSmall,
  ExternalLinkSmall,
  HelpCircleSmall,
  HomeSmall,
  InfoCircleSmall,
  SettingsSmall,
  AddSmall,
  ComposeSmall,
  ConfirmSmall,
  DeleteSmall,
  DismissSmall,
  EditSmall,
  GetStartedSmall,
  LinkSmall,
  RefreshSmall,
  SearchSmall,
  ShareSmall,
  SparklesFilledSmall,
} from '@wix/wix-ui-icons-common';

export const iconsMap = {
  AppMarket: AppMarketSmall,
  Send: SendSmall,
  Coupon: CouponSmall,
  ExternalLink: ExternalLinkSmall,
  HelpCircle: HelpCircleSmall,
  Home: HomeSmall,
  InfoCircle: InfoCircleSmall,
  Settings: SettingsSmall,
  Add: AddSmall,
  Compose: ComposeSmall,
  Confirm: ConfirmSmall,
  Delete: DeleteSmall,
  Dismiss: DismissSmall,
  Edit: EditSmall,
  GetStarted: GetStartedSmall,
  Link: LinkSmall,
  Refresh: RefreshSmall,
  Search: SearchSmall,
  Share: ShareSmall,
  SparklesFilled: SparklesFilledSmall,
};
